import Link from "@mui/material/Link";
import { useTranslate } from "hooks/useTranslate";
import { useAppDispatch } from "redux/hooks";
import { checkUserAccess } from "utils/CommonFunctions";
import { setFeedbackDetails } from "./Snackbar/snackbar.slice";

interface Prop {
  text: string;
  textVariant: any;
  onClick?: any;
  underline?: "always" | "hover" | "none";
  sx?: any;
  type?: string;
  accessType?: string;
}

export default function ButtonLink(props: Prop) {
  const { text, textVariant, onClick, sx, underline = "always", type = "button", accessType } = props;
  const restrictAccess = accessType && !checkUserAccess(accessType);
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const handleClick = (event: any) => {
    if (restrictAccess)
      dispatch(
        setFeedbackDetails({
          shouldShow: true,
          setState: setFeedbackDetails({ shouldShow: false }),
          message: translate("user.restrictAccess")
        })
      );
    else if (onClick) onClick(event);
  };
  return (
    <Link
      component="button"
      variant={textVariant}
      underline={underline}
      onClick={handleClick}
      type={type}
      sx={{ ...sx }}
    >
      {text}
    </Link>
  );
}
